export var spacingTokens = {
  none: '0rem',
  xxxs: '0.2rem',
  xxs: '0.4rem',
  xs: '0.8rem',
  s: '1.2rem',
  m: '1.6rem',
  l: '2rem',
  xl: '2.4rem',
  xxl: '3.2rem',
  xxxl: '4rem'
};